import { all, fork, put, takeEvery } from '@redux-saga/core/effects'
import { carbonNetworksToAPIMap, networksToAPIMap } from '../../constants/NavigationConstants'
import API from 'src/api/api'
import { setNetwork } from '../network/NetworkActions'
import { NetworkTypes } from '../network/NetworkTypes'
import CarbonAPI from 'src/api/carbonApi'
import { NetworkActionTypes } from '../network/NetworkActionTypes'

//watcher
function* updateNetwork() {
  yield takeEvery(NetworkActionTypes.UPDATE_NETWORK, setSelectedNetwork)
}

//worker
function* setSelectedNetwork(action: NetworkTypes) {
  yield put(setNetwork(action.network))
  yield (API.defaults.baseURL = networksToAPIMap.get(action.network))
  yield (CarbonAPI.defaults.baseURL = carbonNetworksToAPIMap.get(action.network))
}

export function* NetworkSaga() {
  yield all([fork(updateNetwork)])
}
